import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function ReservedProductsCtrl (
  $scope,
  $state,
  $translate,
  tableApi,
  workshopAPI
) {
  $scope.showProductReserved = !!$scope.reserved.length;
  $scope.tableCacheKey       = 'productReserved';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'job_card_number',
        header: {
          text: $translate.instant('INVOICE_SPACE.JOB_CARD_NUMBER')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'invoice_type',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.TRAN_TYPE')
        },
        pipe: 'invoiceType'
      },
      {
        field : 'quantity',
        header: {
          text: $translate.instant('PRODUCT_SPACE.QTY')
        }
      },
      {
        field : 'amount',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewInvoice(event)
            }
          },
          enabled: true,
          factory: EditComponent
        },
        sortable: false
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/products/reserved_invoice_count', $scope.product.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'post_date'
    })
  };

  $scope.getReserved = ( params ) => {
    return workshopAPI.get('/products/reserved_invoice_list', [
      $scope.product.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(reserved => {
      $scope.reserved = reserved;

      return reserved;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewInvoice(event.row);
  };

  $scope.viewInvoice = function (invoice) {
    if (invoice.contains_vehicle_sale) {
      $state.go('app.dealership.sale', {
        customer_id: invoice.customer_id,
        id         : invoice.id,
      });
    }
    else {
      $state.go('app.invoice', {
        customer_id: invoice.customer_id,
        id         : invoice.id,
        vehicle_id : invoice.vehicle_id
      });
    }
  };
};